import { render, staticRenderFns } from "./SecurityRules.vue?vue&type=template&id=2e603549&scoped=true"
import script from "./SecurityRules.vue?vue&type=script&lang=js"
export * from "./SecurityRules.vue?vue&type=script&lang=js"
import style0 from "./SecurityRules.vue?vue&type=style&index=0&id=2e603549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e603549",
  null
  
)

export default component.exports